import { mapGetters } from 'vuex'
const DEFAULT_URL = process.env.VUE_APP_BASE_URL + 'terminal/?id=' + mapGetters.getTerminalId
const LOCAL = 'localhost:8080/' + 'terminal/?id=' + mapGetters.getTerminalId
export default {
  Auth: {
      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      // identityPoolId: 'ap-southeast-2_soiOPC3Rc',
      // REQUIRED - Amazon Cognito Region
      region: process.env.VUE_APP_REGION,
      // OPTIONAL - Amazon Cognito Federated Identity Pool Region
      // Required only if it's different from Amazon Cognito Region
      // identityPoolRegion: 'XX-XXXX-X',
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: process.env.VUE_APP_COGNITO_POOL_ID,
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
      // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
      mandatorySignIn: false,
      // OPTIONAL - Configuration for cookie storage
      // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
      // cookieStorage: {
      //     // REQUIRED - Cookie domain (only required if cookieStorage is provided)
      //     domain: '.yourdomain.com',
      //     // OPTIONAL - Cookie path
      //     path: '/',
      //     // OPTIONAL - Cookie expiration in days
      //     expires: 365,
      //     // OPTIONAL - Cookie secure flag
      //     // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
      //     // secure: true
      // },
      // OPTIONAL - customized storage object
      // storage: new MyStorage(),
      // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
      // authenticationFlowType: 'USER_PASSWORD_AUTH',
      // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
      // clientMetadata: { myCustomKey: 'myCustomValue' },
      // OPTIONAL - Hosted UI configuration
      oauth: {
          domain: 'bmcpuat.auth.ap-southeast-2.amazoncognito.com',
          scope: ['graphql/api'],
          redirectSignIn: DEFAULT_URL || LOCAL,
          redirectSignOut: DEFAULT_URL || LOCAL,
          responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
      }
    }
  }